import { deepcopy } from './utility.js';

export async function RCTransformation(role, spec, original, specifier, action, option, rc) {
  if (spec.layout[rc] === undefined) spec.layout[rc] = [];
  for (let i = 0; i < spec.layout[rc]?.length; i++) {
    if (spec.layout[rc][i].constructor.name == "String") {
      spec.layout[rc][i] = { field: spec.layout[rc][i] };
    }
  }
  let layer_specific = (specifier.layer !== undefined);
  let layer_index = (layer_specific && specifier.layer.index !== undefined ? specifier.layer.index : undefined);
  let layer_mark = (layer_specific ? specifier.layer.mark || undefined : undefined);

  let applied_layer_index;
  if (layer_specific) {
    applied_layer_index = spec.layer.map((layer, li) => {
      if (layer_index !== undefined && layer_mark !== undefined)
        return (layer.mark.type === layer_mark) && (li == layer_index) ? li : undefined;
      else if (layer_index !== undefined)
        return (li == layer_index) ? li : undefined;
      else if (layer_mark !== undefined)
        return (layer.mark.type === layer_mark) ? li : undefined;
    })
    applied_layer_index = applied_layer_index.filter(d => d !== undefined);
  }

  if (!layer_specific && ["modify", "add"].includes(action)) {
    // default
    if (!spec.layer) {
      spec.layer = [];
    }
    if (spec.layer.length == 0) {
      spec.layer.push({
        name: "layer_0",
        mark: { type: "point" }
      })
    }
  }

  function getRcElem(method) {
    if (method === undefined) {
      return spec.layout[rc].filter((d, fi) => {
        let flag = true;
        if (specifier.field) {
          flag = (d === specifier.field || d.field === specifier.field || (d.constructor.name === "Array" && (d.includes(specifier.field) || d.map(dd => dd.field).includes(specifier.field))))
        }
        if (!flag) return false;
        if (flag && specifier.index !== undefined) {
          if (fi === specifier.index) return true;
          else if (fi === 0 & specifier.index === "first") return true;
          else if (fi === spec.layout[rc].length - 1 & specifier.index === "last") return true;
          else return false;
        }
        return true;
      });
    } else if (method === "index") {
      return spec.layout[rc].map((d, fi) => {
        let flag = true;
        if (specifier.field) {
          flag = (d === specifier.field || d.field === specifier.field || (d.constructor.name === "Array" && (d.includes(specifier.field) || d.map(dd => dd.field).includes(specifier.field)))) ? fi : undefined;
        }
        if (flag === undefined) return false;
        if (flag && specifier.index !== undefined) {
          if (fi === specifier.index) return fi;
          else if (fi === 0 & specifier.index === "first") return fi;
          else if (fi === spec.layout[rc].length - 1 & specifier.index === "last") return fi;
          else return undefined;
        }
        return fi;
      });
    }
  }

  if (!applied_layer_index) {
    let rcElem = getRcElem();
    rcElem.forEach((fItem, fi) => {
      if (action === "modify" && option !== undefined) {
        Object.keys(option).forEach(propertyKey => {
          if (propertyKey === "field") {
            fItem.field = option.field;
          } else if (propertyKey === "sort") {
            if (option.sort == null) {
              delete fItem.sort;
            } else {
              if (fItem.sort === undefined) fItem.sort = {};
              if (option.sort.constructor.name === "String") fItem.sort = option.sort;
              else if (option.sort.constructor.name === "Array") {
                if (fItem.sort === undefined) fItem.sort.order = [];
                fItem.sort.order = option.sort;
              } else if (option.sort.constructor.name === "Object") {
                if (fItem.sort === undefined) fItem.sort.order = [];
              }
              if (option.sort?.sortBy !== undefined) {
                fItem.sort = { order: option.sort.sortBy };
              } else if (option.sort.order !== undefined) {
                fItem.sort = { order: option.sort.order };
              }
              if (option.sort.reverse !== undefined) fItem.sort.reverse = option.sort.reverse;
            }
          } else if (propertyKey === "scale") {
            if (option.scale === null) delete fItem.scale;
            else {
              if (fItem.scale === undefined) fItem.scale = {};
              Object.keys(option[propertyKey]).forEach(subpropkey => {
                if (option[propertyKey][subpropkey] === null) delete fItem.scale[subpropkey];
                else fItem.scale[subpropkey] = option[propertyKey][subpropkey]
              })
            }
          } else if (propertyKey === "stack") {
            if (option[propertyKey] === null) delete fItem.stack;
            else fItem.stack = option[propertyKey];
          } else if (propertyKey === "aggregate") {
            if (option.aggregate === null) { delete fItem.aggregate; }
            else { fItem.aggregate = option[propertyKey]; }
          } else if (propertyKey === "bin") {
            if (option.bin === null) { delete fItem.bin; }
            else {
              if (option[propertyKey].constructor.name == "Boolean") {
                fItem.bin = { "bin": option[propertyKey] };
              } else if (option[propertyKey].constructor.name == "Object") {
                if (fItem.bin === undefined) fItem.bin = {};
                Object.keys(option[propertyKey]).forEach(subPropkey => {
                  let _subPropkey = { "nBins": "maxbins", "nice": "nice", "minstep": "minstep", "step": "step", "steps": "steps" }[subPropkey]
                  fItem.bin[_subPropkey] = option[propertyKey][subPropkey];
                });
              }
            }
          } else if (propertyKey === "type") {
            fItem.type = option[propertyKey];
          }
        });
      } else if (action === "remove") {
        fItem.delete = true;
      } else if (action === "replace") {
        if (option?.to !== undefined) {
          let newEnc = deepcopy(fItem);
          if (option.to.role === "mark" && option.to.channel !== undefined) {
            spec.layer.forEach(layerItem => {
              if (option.to.mark === undefined || layerItem.mark.type === option.to.mark) {
                layerItem.mark[option.to.channel] = newEnc;
              }
            })
          } else if (["view.row", "row", "view.column", "column"].includes(option.to.role)) {
            let newRC = option.to.role.endsWith("row") ? "row" : "column";
            if (option.to.index !== undefined) {
              spec.layout[newRC] = spec.layout[newRC].splice(option.to.index, 0, deepcopy(fItem));
            } else {
              if (!spec.layout[newRC]) spec.layout[newRC] = [];
              spec.layout[newRC].push(deepcopy(fItem));
            }
          }
          fItem.delete = true;
        }
      } else if (action === "swap") {
        if (option?.to !== undefined) {
          let newEnc = deepcopy(fItem);
          if (option.to.role === "encoding" && option.to.mark !== undefined && option.to.channel !== undefined) {
            let target_layer = spec.layer.filter(l => l.mark.type == option.to.mark)[0]
            if (target_layer !== undefined) {
              let newRC = deepcopy(target_layer.mark[option.to.channel]);
              fItem.field = newRC.field;
              if (spec.datatype?.[newRC.field]?.type) fItem.type = spec.datatype?.[newRC.field]?.type;
              else if (fItem.type) delete fItem.type;
              target_layer.mark[option.to.channel] = newEnc;
            }
          }
        }
      }
    });
    if (action === "add" && option.field !== undefined) {
      if (spec.layout[rc].length <= 1) {
        let fieldObj = {};
        if (option.field) fieldObj.field = option.field;
        if (option.type) fieldObj.type = option.type;
        if (option.values) fieldObj.values = option.values;
        if (option.aggregate) fieldObj.aggregate = option.aggregate;
        if (option.bin !== undefined) {
          if (option[propertyKey].constructor.name == "Boolean") {
            fieldObj.bin = { "bin": option[propertyKey] };
          } else if (option[propertyKey].constructor.name == "Object") {
            if (fieldObj.bin === undefined) fieldObj.bin = {};
            Object.keys(option[propertyKey]).forEach(subPropkey => {
              let _subPropkey = { "nBins": "maxbins", "nice": "nice", "minstep": "minstep", "step": "step", "steps": "steps" }[subPropkey]
              fieldObj.bin[_subPropkey] = option[propertyKey][subPropkey];
            });
          }
        }
        if (option.index !== undefined) spec.layout[rc].splice(option.index, 0, fieldObj);
        else spec.layout[rc].push(fieldObj);
      }
    } else if (action === "swap" && (option === undefined || Object.keys(option).length == 0)) {
      spec.layout[rc] = spec.layout[rc]?.reverse() || [];
    }
    spec.layout[rc] = spec.layout[rc].filter(d => !d.delete);
  } else {
    // for layer-wise, only modify is possible!!!!!!
    applied_layer_index.forEach(li => {
      let layer = spec.layer[li];
      let globalRcElem = getRcElem("index");
      if (!(rc in layer)) {
        layer[rc] = [];
        spec.layout[rc].forEach(e => layer[rc].push({}));
      }
      globalRcElem.forEach((fi) => {
        // if (fi === false) return;
        if (action === "modify") {
          Object.keys(option).forEach(propertyKey => {
            if (propertyKey === "field") {
              layer[rc][fi].field = option.field;
            } else if (propertyKey === "sort") {
              if (layer[rc][fi].sort === undefined) layer[rc][fi].sort = {};
              if (option.sort.constructor.name === "String") layer[rc][fi].sort = option.sort;
              else if (option.sort.constructor.name === "Array") {
                if (layer[rc][fi].sort === undefined) layer[rc][fi].sort.order = [];
                layer[rc][fi].sort.order = option.sort;
              } else if (option.sort.constructor.name === "Object") {
                if (layer[rc][fi].sort === undefined) layer[rc][fi].sort.order = [];
              }
              if (option.sort.sortBy !== undefined) {
                layer[rc][fi].sort.order = option.sort.sortBy;
              }
              if (option.sort.reverse !== undefined) layer[rc][fi].sort.reverse = option.sort.reverse;
            } else if (propertyKey === "scale") {
              if (layer[rc][fi].scale !== undefined) {
                Object.keys(option[propertyKey]).forEach(subpropkey => {
                  if (option[propertyKey][subpropkey] === null) delete layer[rc][fi].scale[subpropkey];
                  else layer[rc][fi].scale[subpropkey] = option[propertyKey][subpropkey]
                })
              }
            } else if (propertyKey === "aggregate") {
              layer[rc][fi].aggregate = option[propertyKey];
            } else if (propertyKey === "stack") {
              if (option[propertyKey] === null) delete layer[rc][fi].stack;
              else layer[rc][fi].stack = option[propertyKey];
            } else if (propertyKey === "bin") {
              if (option[propertyKey].constructor.name == "Boolean") {
                layer[rc][fi].bin = { "bin": option[propertyKey] };
              } else if (option[propertyKey].constructor.name == "Object") {
                if (layer[rc][fi].bin === undefined) layer[rc][fi].bin = {};
                Object.keys(option[propertyKey]).forEach(subPropkey => {
                  let _subPropkey = { "nBins": "maxbins", "nice": "nice", "minstep": "minstep", "step": "step", "steps": "steps" }[subPropkey]
                  layer[rc][fi].bin[_subPropkey] = option[propertyKey][subPropkey];
                });
              }
            } else if (propertyKey === "type") {
              layer[rc][fi].type = option[propertyKey];
            }
          });
        } else
          if (action === "add" && option.field !== undefined) {
            if (layer[rc].length <= 1) {
              let fieldObj = { field: option.field };
              if (option.type) fieldObj.type = option.type;
              if (option.values) fieldObj.values = option.values;
              if (option.index !== undefined) layer[rc].splice(option.index, 0, fieldObj);
              else layer[rc].push(fieldObj);
            }
          } else if (action === "swap" && option === undefined) {
            layer[rc] = layer[rc]?.reverse() || [];
          }
      });
    })
  }
  return spec;
}